'use strict';

import $ from 'jquery';
// noinspection ES6UnusedImports
import test from "./prototyping.js"; // KEEP THIS LINE
// IT IS USED TO FORCE IMPORT ORDER, SO THAT PROTOTYPING ALWAYS LOADS FIRST!

window.animSpeed = 200;
window.animSpeedFast = 100;
window.animSpeedMedium = 500;
window.animSpeedSlow = 1000;

window.popupTimeout = 3000;

/*
 |--------------------------------------------------------------------------
 | Scroll manipulation functions
 |--------------------------------------------------------------------------
 */

export function scrollToTarget($target, offset) {
    if ($target) {
        if (! offset) {
            offset = 0;
        }

        $([document.documentElement, document.body]).scrollTop($target.offset().top + offset);
    }
}

/*
 |--------------------------------------------------------------------------
 | Various (debug) functions
 |--------------------------------------------------------------------------
 */

/**
 * Disable fast click
 */
export function disableFastClick() {
    return false;
}

/*
 |--------------------------------------------------------------------------
 | Slugify function
 |--------------------------------------------------------------------------
 */

(function ($) {

    $.fn.slugify = function (source, options) {
        const $target = this;

        // These sequences must be replaced before the main map is applied
        const sequences = {
            '\'t': 'het',
        };

        // These characters can be replaced with regular alphabetic ones.
        const map = {
            a: ['â','ä','à','å','á'],
            A: ['Å','Ä','À','Å','Á'],
            c: ['ç','¢'],
            C: ['Ç'],
            e: ['é','ê','ë','è'],
            E: ['É','Ê','Ë','È'],
            i: ['ï','î','ì','í'],
            I: ['Ï','Î','Ì','Í'],
            n: ['ñ'],
            N: ['Ñ'],
            o: ['ô','ö','ò','ø','ó'],
            O: ['Ô','Ö','Ò','Ø','Ó'],
            p: ['Þ'],
            s: ['š','§'],
            S: ['Š'],
            u: ['ü', 'û','ù','ú'],
            U: ['Ü','Û','Ù'],
            x: ['×'],
            y: ['ÿ'],
            Y: ['Ÿ'],
            z: ['ž'],
            Z: ['Ž'],
            ae: ['æ'],
            AE: ['Æ'],
            oe: ['œ'],
            OE: ['Œ'],
            th: ['ð'],
            TH: ['Ð'],
            ss: ['ß'],
        }

        function convert(input) {
            for (const k in sequences) {
                input = input.replace(k, sequences[k]);
            }

            return input
                .split('')
                .map(l => {
                    for (let r in map) {
                        if (map[r].includes(l)) {
                            return r;
                        }
                    }
                    // Aside from the special characters mapped earlier, replace all other weird characters with a dash.
                    return l.replace(/\W+/, '-');
                })
                .join('')
                .toLowerCase()
                .replace(/-+/g, '-') // Replace double dashes with a single one
                .replace(/^-|-$/g, ''); // Remove trailing or leading dashes
        }

        $target.val(convert(source));
    };

})(jQuery);

/*
 |--------------------------------------------------------------------------
 | Flash messages
 |--------------------------------------------------------------------------
 */

//functions
function removeFlashMessage() {
    $(this).fadeOut(200);
}

//ready
$(document.body).on('click', '.flash-messages .notification', removeFlashMessage);
$(document.body).on('mousedown', '.flash-messages .notification', disableFastClick);

$(document).ready(function () {

    //remove after a number of seconds
    setTimeout(function() {
        $('.notification.flash-message-remove').fadeOut(200);
    }, 3000);
});

/*
 |--------------------------------------------------------------------------
 | Human readable file size
 |--------------------------------------------------------------------------
 */

export function humanReadableFileSizes(bytes) {
    const staircase = ['','K','M','G','T'];

    let counter = 0;
    while (bytes > 1024 && counter < 4) {
        bytes /= 1024;
        ++counter;
    }

    return bytes.toFixed(2) + ' ' + staircase[counter] + 'B';
}

/*
 |--------------------------------------------------------------------------
 | Tooltips
 |--------------------------------------------------------------------------
 */

/**
 * Tooltip attribute definitions.
 *
 * (optional) data-tooltip-class            Adds the given classes to the tooltip's class list
 *
 * (optional) data-tooltip-width            Sets the width of the tooltip
 *                                              default value: auto
 *                                              passing 'auto' will adjust the width to the content
 *
 * (required) data-tooltip-text             The text set in the tooltip
 *
 * (optional) data-tooltip-text-alignment   Sets the text-alignment
 *                                              possible values: left, right, center
 *                                              default value: center
 *
 * (optional) data-tooltip-alignment        Sets the alignment of the tooltip to the subject
 *                                              possible values: left, right, center
 *                                              default value: center
 *
 * (optional) data-tooltip-arrow-alignment  Sets the alignment of the arrow to the tooltip
 *                                              possible values: left, right, center
 *                                              default value: center
 */
scope(() => {
    /**
     * A weak map reference to existing tooltip instances.
     * @type {WeakMap<HTMLElement, Tooltip>}
     */
    const Tooltips = new WeakMap();

    const container = document.querySelector('.js-tooltip-container');

    // How many ms before moving out of a tooltip will hide it.
    const showDuration = 100;

    const observer = new MutationObserver(records => {
        records.forEach(record => {
            const tooltip = Tooltips.get(record.target);
            if (tooltip) {
                tooltip._updateText(record.target.dataset.tooltipText);
                if (tooltip.isVisible) {
                    tooltip.show();
                }
            }
        });
    });

    const config = {
        attributeFilter: ['data-tooltip-text'],
    }

    class Tooltip {
        constructor(trigger) {
            // console.warn(document, doc, document === doc);
            this.trigger = trigger;
            this.text = trigger.dataset.tooltipText;
            this.classes = trigger.dataset.tooltipClass;
            this.width = trigger.dataset.tooltipWidth || 'auto';
            this.textAlignment = trigger.dataset.tooltipTextAlignment || 'text-center';
            this.tooltipAlignment = trigger.dataset.tooltipAlignment || 'text-center';
            this.arrowAlignment = trigger.dataset.tooltipArrowAlignment || 'text-center';
            this.hideTimeout = null;
            this.isVisible = false;
            this.showDuration = showDuration;

            this._build();
            this._updateText(this.text);

            trigger.on('mouseleave', this.hide.bind(this));
            // this.element.on('mouseover', this.show.bind(this));
            // this.element.on('mouseleave', this.hide.bind(this));
            this.boundHandler = this._scrollHandler.bind(this);
            observer.observe(this.trigger, config);

            Tooltips.set(trigger, this);
        }

        _build() {
            this.element = document.createElement('div');
            this.element.classList.add('js-tooltip-content');
            this.element.style.width = this.width;

            this.body = document.createElement('div');
            this.body.classList.add('js-tooltip-text');
            this.body.style.textAlign = this.textAlignment.replace('text-', '');
            if (this.classes) {
                this.body.className += ' ' + this.classes;
            }

            if (this.body.classList.contains('no-animation')) {
                this.element.classList.add('no-animation');
                this.showDuration = 0;
            }

            this.element.append(this.body);
        }

        _updateText(text) {
            this.text = text;
            this.body.innerHTML = text;
        }

        show() {
            clearTimeout(this.hideTimeout);

            const pos = this.getPosition();

            if (pos.x !== 0 && pos.y !== 0) {
                let left = pos.left,
                    top = pos.top;

                if (! this.element.parentElement) {
                    container.append(this.element);
                    this._bindHandler();
                }

                const size = this.getSize();

                switch (this.tooltipAlignment) {
                    case 'text-center':
                        left -= size.width / 2 - pos.width / 2;
                        break;
                    case 'align-right':
                        left += pos.width - size.width;
                        break;
                }

                if (top - size.height < 0) {// wrap it downwards
                    top += pos.height + 8;
                    this.body.classList.add('arrow-above');
                } else {
                    top -= size.height + 8;
                    this.body.classList.remove('arrow-above');
                }

                if (left + size.width > window.innerWidth) {
                    left -= left + size.width - window.innerWidth;
                }
                if (left < 0) {
                    left = 0;
                }

                this.element.style.top = top + 'px';
                this.element.style.left = left + 'px';

                switch (this.arrowAlignment) {
                    case 'left':
                    case 'align-left':
                        this.body.classList.add('arrow-left');
                        this.body.classList.remove('arrow-right');
                        break;
                    case 'right':
                    case 'align-right':
                        this.body.classList.add('arrow-right');
                        this.body.classList.remove('arrow-left');
                        break;
                    default:
                        this.body.classList.remove('arrow-left');
                        this.body.classList.remove('arrow-right');
                        break;
                }
            }

            this.isVisible = true;
            this.element.classList.add('visible');
        }

        hide() {
            clearTimeout(this.hideTimeout);

            this.hideTimeout = setTimeout(() => {
                this.element.classList.remove('visible');
                this.hideTimeout = setTimeout(this.removeElement.bind(this), this.showDuration);
            }, this.showDuration);
        }

        removeElement() {
            if (this.element.parentNode) {
                this.isVisible = false;
                this.element.remove();
            }

            this._removeHandler();
        }

        forceHide() {
            clearTimeout(this.hideTimeout);

            this.element.classList.remove('visible');
            this.removeElement();
        }

        /**
         * Returns the position of the trigger, in screen space.
         * @return {DOMRect}
         */
        getPosition() {
            return this.trigger.getBoundingClientRect();
        }

        /**
         * Returns the size and position of the tooltip itself.
         * @return {{width: number, height: number}}
         */
        getSize() {
            return {
                width: this.element.offsetWidth,
                height: this.element.offsetHeight
            }
        }

        _bindHandler() {
            window.addEventListener('scroll', this.boundHandler);
            window.addEventListener('resize', this.boundHandler);
        }

        _removeHandler() {
            window.removeEventListener('scroll', this.boundHandler);
            window.removeEventListener('resize', this.boundHandler);
        }

        _scrollHandler() {
            this.forceHide();
        }
    }

    document.body
        .on('mouseover', '.js-toggle-tooltip', event => {
            if (Tooltips.has(event.currentTarget)) {
                Tooltips.get(event.currentTarget).show();
            } else {
                new Tooltip(event.currentTarget).show();
            }
        });
});

// This allows tooltipped elements to be clickable to open a modal with the tooltip's content.
document.on('click', '.js-toggle-tooltip.js-tooltip-clickable', event =>
    new Modal({
        content: event.currentTarget.dataset.tooltipText,
    })
        .open()
);


/*
 |--------------------------------------------------------------------------
 | Password display toggle on the login screen
 |--------------------------------------------------------------------------
 */
(function ($) {
    //Hide or show the contents of a password field
    $(document).ready(() => $('.password-toggle')
        .on('mousedown touchstart', e => e.currentTarget.parentElement.querySelector('input').type = 'text')
        .on('mouseup mouseleave touchend', e => e.currentTarget.parentElement.querySelector('input').type = 'password')
    );

})(jQuery);

